import { render, staticRenderFns } from "./ParentBar.vue?vue&type=template&id=c8cdbd56&"
import script from "./ParentBar.vue?vue&type=script&lang=js&"
export * from "./ParentBar.vue?vue&type=script&lang=js&"
import style0 from "./ParentBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports